export const ChevronRight = ({fillColor = '#212124', width = 16, height = 16}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.25671 3.66896L4.58774 2.92567L6.07433 1.58774L6.74329 2.33104L5.25671 3.66896ZM10.5 8L11.2433 7.33104L11.8454 8L11.2433 8.66896L10.5 8ZM6.74329 13.669L6.07433 14.4123L4.58774 13.0743L5.25671 12.331L6.74329 13.669ZM6.74329 2.33104L11.2433 7.33104L9.75671 8.66896L5.25671 3.66896L6.74329 2.33104ZM11.2433 8.66896L6.74329 13.669L5.25671 12.331L9.75671 7.33104L11.2433 8.66896Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default ChevronRight;
